// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoadsStatusCards_row__933lk {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 12px;
}

.LoadsStatusCards_card__hTe2I {
  background: var(--dylo-surface);
  border: var(--dylo-card-border-width) solid var(--dylo-surface-border);
  border-radius: 14px;
  box-shadow: var(--shadow-card);
  padding: 10px 10px 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-family: var(--font-sans);
  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.05s ease;
}
.LoadsStatusCards_card__hTe2I:hover {
  border-color: var(--card-color);
}
.LoadsStatusCards_card__hTe2I:active {
  transform: translateY(1px);
}
.LoadsStatusCards_card__hTe2I.LoadsStatusCards_active__J\\+LED {
  border-color: var(--card-color);
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--card-color) 40%, transparent);
}

.LoadsStatusCards_pill__O9OQN {
  width: 100%;
  text-align: center;
  color: #fff;
  font-size: 12.5px;
  font-weight: 600;
  text-transform: uppercase;
  padding: 6px 8px;
  border-radius: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.LoadsStatusCards_count__qpp8N {
  font-size: 24px;
  font-weight: 700;
  line-height: 1;
  /*
   * Se remonta al aplicar filtros (key = pulse + valor), así que la animación
   * vuelve a correr y el cambio de número se nota.
   * Solo opacidad y escala: sin desplazamiento, para no generar scroll.
   */
  animation: LoadsStatusCards_count-change__Flx9S 0.44s cubic-bezier(0.16, 1, 0.3, 1) both;
}
@keyframes LoadsStatusCards_count-change__Flx9S {
  0% { opacity: 0; transform: scale(0.72); }
  60% { opacity: 1; transform: scale(1.06); }
  100% { opacity: 1; transform: scale(1); }
}

/* Card sin resultados bajo los filtros actuales: se atenúa */
.LoadsStatusCards_cardEmpty__2fPyP {
  opacity: 0.45;
}
.LoadsStatusCards_cardEmpty__2fPyP:hover {
  opacity: 0.75;
}

/*
 * Cuando hay filtros activos los conteos ya no son el total del sistema:
 * un borde punteado sutil en el contenedor lo insinúa sin ser invasivo.
 */
.LoadsStatusCards_rowFiltered__cdeIP .LoadsStatusCards_card__hTe2I {
  border-style: dashed;
}
.LoadsStatusCards_rowFiltered__cdeIP .LoadsStatusCards_card__hTe2I.LoadsStatusCards_active__J\\+LED {
  border-style: solid;
}

@media (prefers-reduced-motion: reduce) {
  .LoadsStatusCards_count__qpp8N {
    animation: none;
  }
}

@media (max-width: 1280px) {
  .LoadsStatusCards_row__933lk {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (max-width: 680px) {
  /* \`minmax(0, 1fr)\` y no \`1fr\` (26-oct-2026): con \`1fr\` una tarjeta con un número o una etiqueta larga ensanchaba su
     columna y la otra se quedaba angosta (lo que le pasaba al login con sus campos). */
  .LoadsStatusCards_row__933lk {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
`, "",{"version":3,"sources":["webpack://./src/v2/pages/Loads/components/LoadsStatusCards.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,sEAAsE;EACtE,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,6BAA6B;EAC7B,gFAAgF;AAClF;AACA;EACE,+BAA+B;AACjC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,+BAA+B;EAC/B,4EAA4E;AAC9E;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd;;;;IAIE;EACF,wFAAgE;AAClE;AACA;EACE,KAAK,UAAU,EAAE,sBAAsB,EAAE;EACzC,MAAM,UAAU,EAAE,sBAAsB,EAAE;EAC1C,OAAO,UAAU,EAAE,mBAAmB,EAAE;AAC1C;;AAEA,6DAA6D;AAC7D;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA;;;EAGE;AACF;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;uFACqF;EACrF;IACE,gDAAgD;EAClD;AACF","sourcesContent":[".row {\n  display: grid;\n  grid-template-columns: repeat(8, 1fr);\n  gap: 12px;\n}\n\n.card {\n  background: var(--dylo-surface);\n  border: var(--dylo-card-border-width) solid var(--dylo-surface-border);\n  border-radius: 14px;\n  box-shadow: var(--shadow-card);\n  padding: 10px 10px 14px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  font-family: var(--font-sans);\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.05s ease;\n}\n.card:hover {\n  border-color: var(--card-color);\n}\n.card:active {\n  transform: translateY(1px);\n}\n.card.active {\n  border-color: var(--card-color);\n  box-shadow: 0 0 0 2px color-mix(in srgb, var(--card-color) 40%, transparent);\n}\n\n.pill {\n  width: 100%;\n  text-align: center;\n  color: #fff;\n  font-size: 12.5px;\n  font-weight: 600;\n  text-transform: uppercase;\n  padding: 6px 8px;\n  border-radius: 8px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.count {\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 1;\n  /*\n   * Se remonta al aplicar filtros (key = pulse + valor), así que la animación\n   * vuelve a correr y el cambio de número se nota.\n   * Solo opacidad y escala: sin desplazamiento, para no generar scroll.\n   */\n  animation: count-change 0.44s cubic-bezier(0.16, 1, 0.3, 1) both;\n}\n@keyframes count-change {\n  0% { opacity: 0; transform: scale(0.72); }\n  60% { opacity: 1; transform: scale(1.06); }\n  100% { opacity: 1; transform: scale(1); }\n}\n\n/* Card sin resultados bajo los filtros actuales: se atenúa */\n.cardEmpty {\n  opacity: 0.45;\n}\n.cardEmpty:hover {\n  opacity: 0.75;\n}\n\n/*\n * Cuando hay filtros activos los conteos ya no son el total del sistema:\n * un borde punteado sutil en el contenedor lo insinúa sin ser invasivo.\n */\n.rowFiltered .card {\n  border-style: dashed;\n}\n.rowFiltered .card.active {\n  border-style: solid;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .count {\n    animation: none;\n  }\n}\n\n@media (max-width: 1280px) {\n  .row {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n@media (max-width: 680px) {\n  /* `minmax(0, 1fr)` y no `1fr` (26-oct-2026): con `1fr` una tarjeta con un número o una etiqueta larga ensanchaba su\n     columna y la otra se quedaba angosta (lo que le pasaba al login con sus campos). */\n  .row {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `LoadsStatusCards_row__933lk`,
	"card": `LoadsStatusCards_card__hTe2I`,
	"active": `LoadsStatusCards_active__J+LED`,
	"pill": `LoadsStatusCards_pill__O9OQN`,
	"count": `LoadsStatusCards_count__qpp8N`,
	"count-change": `LoadsStatusCards_count-change__Flx9S`,
	"cardEmpty": `LoadsStatusCards_cardEmpty__2fPyP`,
	"rowFiltered": `LoadsStatusCards_rowFiltered__cdeIP`
};
export default ___CSS_LOADER_EXPORT___;
